import React, { useEffect, useReducer } from "react"
import styled from "@emotion/styled"
import {
  calcPrices,
  countryList,
  loadScriptAndExecute,
  priceReducer,
} from "./GumroadUtils"
import { Button } from "theme-ui"

function GumroadOverlay({ code, price, text, useCoupon = true, ...props }) {
  const [{ upgradeTier, location, adjusted }, dispatch] = useReducer(
    priceReducer,
    {
      data: {
        upgradeTier: null,
        location: {},
        adjusted: false,
      },
    }
  )

  useEffect(() => {
    if (useCoupon && price) {
      calcPrices(price, dispatch)
    }
    loadScriptAndExecute(
      "https://gumroad.com/js/gumroad.js",
      "createGumroadOverlay"
    )
  }, [price, useCoupon])

  const country = location && location.country_name
  const coupon =
    useCoupon && country && countryList.includes(country.toLowerCase())
      ? country
      : country && location.continent_code

  const url = coupon
    ? `https://gumroad.com/l/${code}/${coupon}?wanted=true`
    : `https://gumroad.com/l/${code}?wanted=true`

  return (
    <GumroadWrapper>
      <Button as="a" {...props} className="btn" href={url}>
        {text ? text : <span>Upgrade for ${upgradeTier}</span>}
      </Button>
      <div>
        {adjusted ? (
          <small>
            {" "}
            <span role="img" aria-label="heart">
              ❤️
            </span>
            price parity adjusted for {country}{" "}
            <span role="img" aria-label="heart">
              ❤️
            </span>
          </small>
        ) : null}
      </div>
    </GumroadWrapper>
  )
}

const GumroadWrapper = styled.div`
  margin: 2rem auto;
  display: inline-block;
  max-width: 500px;

  small {
    font-size: 0.7rem;
    vertical-align: middle;
    color: #808080;
    margin-top: 0.5em;
    display: inline-block;
  }
`

export default GumroadOverlay
